import React from "react";
import "react-table-v6/react-table.css";
import {
  Icon,
  Modal,
  Dropdown,
  Label,
  Loader,
  Form,
  Grid,
  Input,

} from "semantic-ui-react";
import { bindActionCreators } from "redux";
import ButtonHandler from "../ButtonHandler.jsx";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
  fetchDashboardData, fetchMasterData, downloadDisbursementReportAction,
  getDisbursementSummaryFormat, getDisbursementSummaryData
} from "../../actions/users_action";
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarDensitySelector } from "@mui/x-data-grid";
import config from "../../config.js";
import DataTable from "../ControlPanelComponents/DataTable.jsx";
const storageBaseUrl = config["storage_base_url"];
import DisbursementSummaryDataView from "./DisbursementSummaryDataView.jsx";
import HFSSummaryDataView from "./HFSSummaryDataView.jsx";
class DashboardTabView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selection: [],
      pageSize: 15,
      master: [],
      templateId: '',
      templates: [],
      selectedTemplate: '',
      selectedDashboard: '',
      summaryFormat: '',
      modalOpen: false,
      currentFile: {},
      fileName: '',
      disSummaryData: [],
      disHFSData:[],
      loaderStatus: false,
      summaryData: '',
      hfsData:'',
      disPendingData: [],
      disPivotData: [],
      disCorpData:[],
      disLatData:[],
      disOneOffData:[],
      disSubdPi:[],
      disInprogressData:[],
      selectedMonth:'',
      selectedYear:'',
      rolling_summary_url:''
    };
  }

  async componentDidMount() {

    await this.props.fetchMasterData({
      onSuccess: (res) => {
        this.setState({ 'templates': res.templates, 'distributors': res.distributors })
        let tempId = res.templates[-1]._id
        this.setState({ templateId: tempId })
        this.props.fetchDashboardData(res.templates[res.templates.length - 1]['_id'], {
          onSuccess: (res) => {
            this.setState({ master: res.dashboard })
          },
          onFailure: () => {

          }
        })
      },
      onFailure: () => {

      }
    })
  }

  dropDownTemplateOnChange = (e, data) => {

    // let templateId = ''
    // data.options.map((d) => {
    //   if (data.value == d.value) {
    //     templateId = d.key
    //   }
    // })

    let templateId = ''
    let selectedTemplate = ''
    data.options.map((d) => {
      if (data.value == d.value) {
        console.log(data,'ddddd')
        templateId = d.key
        selectedTemplate = data.value
      }
    })
    

    const str = selectedTemplate;

    const parts = str.split(" - ")[1]; 

    const [monthName, year] = parts.split(" ");

    const monthMap = {
      January: 0, February: 1, March: 2, April: 3,
      May: 4, June: 5, July: 6, August: 7,
      September: 8, October: 9, November: 10, December: 11
    };

    const month = monthMap[monthName];

     this.setState({ selectedTemplate: selectedTemplate, templateId: templateId,selectedMonth:month,selectedYear:parseInt(year) })

    this.props.fetchDashboardData(templateId, {
      onSuccess: (res) => {
        this.setState({ master: res.dashboard })
      },
      onFailure: () => {

      }
    })
    if(this.state.selectedDashboard == 'Pre-Disbursement Tracker'){
      this.setState({fileName:'disbursementSummary'})
    }
    else{
      this.setState({fileName:'hfsSummary'})
    }

    this.props.getDisbursementSummaryFormat(templateId,this.state.fileName, {
      onSuccess: (res) => {
        if(this.state.selectedDashboard == 'Pre-Disbursement Tracker'){
          if (res.summary_format !== '') {
            this.setState({ 'summaryFormat': res.summary_format })
          }
          if(res.rolling_summary_url && res.rolling_summary_url != ''){
            this.setState({rolling_summary_url:res.rolling_summary_url})
          }
          else{
            this.setState({rolling_summary_url:''})
          }
        }
        else if(this.state.selectedDashboard == 'HFS Tracker'){
          if (res.summary_format !== '') {
            this.setState({ 'hfsFormat': res.summary_format })
          }
        }
        
       
      },
      onFailure: () => {

      }
    })
    let sum_data = {
      templateId: templateId,
      role: 'dist',
      location: this.props.auth.location,
      type:this.state.selectedDashboard
    }
    this.props.getDisbursementSummaryData(sum_data, {
      onSuccess: (res) => {
        if(this.state.selectedDashboard == 'Pre-Disbursement Tracker'){
          if (res.summary_data != undefined && res.summary_data.length > 0) {
            let corp = []
                let lat = []
                let oneOff = []
                let status = []
                let qps = []
                let pivot = []
                let count = 0
                res.summary_data.forEach((d)=>{
                  if(d.types && d.types == 'Corporate'){
                    corp.push(d)
                  }
                  else if(d.types && d.types == 'LAT'){
                    lat.push(d)
                  }
                  else if(d.types && d.types == 'oneOff'){
                    oneOff.push(d)
                  }
                  else if(d.types && d.types == 'status') {
                    status.push(d);
                    
                    let found = pivot.find(p => p.Status === d.Status);
                    if (found) {
                      found["Program Name / Plans"] += 1;
                    } else {
                      count++;
                      pivot.push({
                        Status: d.Status,
                        "Program Name / Plans": 1,
                        "id": count
                      });
                    }
                  }
                  else if(d.types && d.types == 'qpsWorking'){
                    qps.push(d)
                  }
                })
                this.setState({ disSummaryData: [],disCorpData: corp,disLatData:lat,disOneOffData:oneOff,disQPSData:qps,disStatusData:status,disPivotData:pivot })
          }
          else {
            this.setState({ disSummaryData: [],disCorpData: [] })
          }
          if(res.rolling_summary_url && res.rolling_summary_url != ''){
            this.setState({rolling_summary_url:res.rolling_summary_url})
          }
          else{
            this.setState({rolling_summary_url:''})
          }
        }
        else if(this.state.selectedDashboard == 'HFS Tracker'){
          if (res.summary_data != undefined && res.summary_data.length > 0) {
            this.setState({ disHFSData: res.summary_data })
          }
          else {
            this.setState({ disHFSData: []})
          }
        }
      },
      onFailure: () => {

      }
    })
  }

  dropDownDashboardOnChange = (e, data) => {
    this.setState({ selectedDashboard: data.value })
  }

  downloadTracker = () => {
    let templateId = this.state.templateId
    this.props.downloadDisbursementReportAction(templateId, {
      onSuccess: () => {

      },
      onFailure: () => {

      }
    })
  }

  downloadSummaryFormat = () => {
    if (this.state.summaryFormat !== '') {
      window.open(storageBaseUrl + this.state.summaryFormat);
    }
  }

  closeuploadoption = () => {
    this.setState({ modalOpen: false })
  }

  fileupload = (file) => {
    this.setState({ currentFile: file.target.files[0], fileUploaded: true })
  };

  uploadSummary = (file_type) => {

  }


  uploadFile = (fileName) => {

    this.setState({ fileName: fileName, modalOpen: true })

  }

  downloadHFSFormat = () => {
    if (this.state.hfsFormat !== '') {
      window.open(storageBaseUrl + this.state.hfsFormat);
    }
    else {
      alert("File Not Available")
    }
  }

  downloadHFSData = () => {
    if (this.state.hfsData !== '') {
      window.open(storageBaseUrl + this.state.hfsData);
    }
    else {
      alert('File Not Available')
    }
  }

  render() {

    var templateMonths = []

    this.state.templates.map((d) => {
      templateMonths.push({
        'key': d._id,
        'value': d.name,
        'text': d.name
      })
    })

    var dashboardsList = [

      {
        'key': 'Pre-Disbursement Tracker',
        'value': 'Pre-Disbursement Tracker',
        'text': 'Pre-Disbursement Tracker'
      },
      {
        'key': 'HFS Tracker',
        'value': 'HFS Tracker',
        'text': 'HFS Tracker'
      },

    ]

    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexFlow: "column",
          height: "86vh",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >

        <div style={{ height: '100%', flex: 1 }} >

          <h1
            style={{

              flex: "0 0 30px",
              display: "inline-block",
              color: "#2185d0",
            }}
          >
            Disbursement Dashboard
          </h1>   <Dropdown placeholder='Select Dashboard' search selection options={dashboardsList}
            onChange={this.dropDownDashboardOnChange}
            value={this.state.selectedDashboard}
            style={{ marginLeft: 40 }}

          />
          <br />

          {this.state.selectedDashboard == 'Pre-Disbursement Tracker' &&
            <div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>

                <div>
                  <Dropdown placeholder='Select Month' search selection options={templateMonths}
                    onChange={this.dropDownTemplateOnChange}
                    value={this.state.selectedTemplate}

                  />
                </div>
              </div>
              <div>
             
               
                 {this.state.disCorpData.length > 0 &&
                                 <div>
                                   <br></br>
                                   <h3>Overall Status</h3>
                                   {console.log(this.state.disPivotData,'pivot')}
                                   <DisbursementSummaryDataView  data={this.state.disPivotData} types={'overall'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                                   <br></br>
                                    <h3>Disbursement Wise Status</h3>
               
                                   <DisbursementSummaryDataView  data={this.state.disStatusData} types={'status'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                                   <br></br>
                                   
                                   <h3>Corporate Status</h3>
               
                                   <DisbursementSummaryDataView  data={this.state.disCorpData} types={'corp'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                                   <br></br>
                                   <h3>LAT Status</h3>
               
                                   <DisbursementSummaryDataView  data={this.state.disLatData} types={'lat'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                                   <br></br>
                                   <h3>OneOff Display Status</h3>
               
                                   <DisbursementSummaryDataView  data={this.state.disOneOffData} types={'oneoff'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                   
                                   <br></br>
                                   <h3>QPS Status</h3>
               
                                   <DisbursementSummaryDataView  data={this.state.disQPSData} types={'qps'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                                   <br></br>
                                  
                                 </div>
               
                               }
              </div>
            </div>

          }
          {this.state.selectedDashboard == 'HFS Tracker' &&
            <div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>

                <div>
                  <Dropdown placeholder='Select Month' search selection options={templateMonths}
                    onChange={this.dropDownTemplateOnChange}
                    value={this.state.selectedTemplate}

                  />
                </div>
             
               
              </div>
              <div>
                {this.state.disHFSData.length > 0 &&
                  <div>
                    <br></br>
                    <br></br>
                    <HFSSummaryDataView data={this.state.disHFSData}/>
                  </div>
                }
              </div>
            </div>

          }
        </div>

        {/* <Modal
          open={this.state.modalOpen}
          onClose={this.closeuploadoption}
          size="mini"
        >
          <Modal.Content>
            <Form>
              <Grid columns={1}>
                <Grid.Row>

                  <Grid.Column style={{ marginTop: 20 }}>
                    <h4>Upload Summary Sheet :</h4>
                    <Input
                      type="file"
                      accept=".xlsx"
                      onChange={this.fileupload}
                      multiple
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </Modal.Content>

          <Modal.Actions>
            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
              <ButtonHandler
                click={this.uploadSummary}
                title={'Upload'}
                color={'green'}
                iconColor={'white'}
                disabled={this.state.fileUploaded == true ? false : true}
              />
              <ButtonHandler
                click={this.closeuploadoption}
                isIcon={true}
                color={'red'}
                iconName={'remove'}
                iconColor={'white'}
                title={'Close'}
              />
            </div>

          </Modal.Actions>
          {this.state.loaderStatus && (
            <Dimmer active inverted>
              <Loader inverted>Loading</Loader>
            </Dimmer>
          )}
        </Modal> */}

      </div>
    );
  }
}

function AuditTableCell(props) {
  function onClick() {
    props.onClick(props.row);
  }
  return (
    <div style={props.style} onClick={onClick}>
      {props.text}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchDashboardData,
      fetchMasterData,
      downloadDisbursementReportAction,
      getDisbursementSummaryFormat, getDisbursementSummaryData
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardTabView)
);
